import Service from "../../AuthService";

const BagData = {
    getBagData(page) {
        //console.log("/bag_data?page="+page);
        return Service.get("/bag_data?page=" + page);
    },
    showBagData(id) {
        return Service.get("/bag_data/" + id);
    },
    createBagData(data) {
        return Service.post("/bag_data", data);
    },
    updateBagData(id, data) {
        return Service.put("/bag_data/" + id, data);
    },
    deleteBagData(id) {
        return Service.delete("/bag_data/" + id);
    },
    getBagDataFromType(page, type_id) {
        return Service.get('/bag_data_from_type/' + type_id + '?page=' + page);
    },
    getBagType() {
        return Service.get("/bag_type_all");
    },
    getBagDataFromStatus() {
        return Service.get("/bag_data_from_status")
    },
    searchBagData(data) {
        return Service.get("/bag_data_search?page=" + data.page + "&seen=" + data.seen + "&bag_id=" + data.bag_id + "&vendor_id=" + data.vendor_id + "&type_id=" + data.type_id + "&date_start=" + data.date_start + "&date_end=" + data.date_end + "&excel=" + data.excel);
    },
    getBagDataAll() {
        return Service.get("/bag_data_all");
    }

};
export default BagData;
